import clsx from "clsx";
import { createElement, type HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Ground: Clinic White, Soft Blue, or Harbor Navy. */
  tone?: "card" | "tinted" | "inverse";
  /** 16 px padding instead of 24 px. */
  dense?: boolean;
  as?: "div" | "section" | "article" | "li";
}

/**
 * Card per 10_component-anatomy.md: radius-md, 24 px padding, and a Slate
 * boundary because neither Clinic White nor Soft Blue separates from the
 * Cool Off-White canvas by fill alone. No shadow is needed for structure.
 */
export function Card({ tone = "card", dense = false, as = "div", className, ...rest }: CardProps) {
  return createElement(as, {
    ...rest,
    className: clsx(
      "rounded-md border",
      dense ? "p-4" : "p-6",
      tone === "card" && "bg-card border-rule-strong",
      tone === "tinted" && "bg-card-tinted border-rule-strong surface-card-tinted",
      tone === "inverse" && "bg-inverse text-ink-inverse border-rule-inverse surface-inverse",
      className,
    ),
  });
}
